import Reveal from "./Reveal";

const Line = ({ width = "100%", dark = false, className = "" }) => (
  <div
    className={`doc-line ${dark ? "dark" : ""} ${className}`}
    style={{ width }}
    aria-hidden="true"
  />
);

export const DocPreview = () => (
  <Reveal delay={120}>
    <div
      data-testid="hero-doc-preview"
      className="doc-preview mx-auto w-full max-w-[440px]"
      aria-hidden="true"
    >
      <div className="doc-bar">Adheran Compliance Pack</div>

      <div className="px-6 pt-6 pb-8">
        <p className="text-[10.5px] font-semibold tracking-[0.2em] uppercase" style={{ color: "var(--muted-2)" }}>
          Section 01
        </p>
        <h4 className="mt-1 text-[15px] font-semibold tracking-tight" style={{ color: "var(--ink)" }}>
          AI Inventory Register · v1
        </h4>

        <div className="mt-5 space-y-2.5">
          <Line width="92%" dark />
          <Line width="78%" />
          <Line width="84%" />
          <Line width="70%" />
          <Line width="88%" />
        </div>

        <div className="mt-7 border-t pt-5" style={{ borderColor: "var(--line-2)" }}>
          <p className="text-[10.5px] font-semibold tracking-[0.2em] uppercase" style={{ color: "var(--muted-2)" }}>
            Section 02
          </p>
          <h4 className="mt-1 text-[15px] font-semibold tracking-tight" style={{ color: "var(--ink)" }}>
            Annex III Risk Assessment
          </h4>
          <div className="mt-4 space-y-2.5">
            <Line width="80%" dark />
            <Line width="64%" />
            <Line width="74%" />
          </div>
        </div>

        <div className="mt-12 h-6" />
      </div>

      <div className="doc-stamp">Audit-ready</div>
    </div>
  </Reveal>
);

export default DocPreview;
